module.exports = __webpack_public_path__ + "img/sponsors-08.9d177386.png";